export default "__VITE_ASSET__ccd4dd7a__"